import React, { useState, useEffect } from 'react';
import api from '../services/api';

function Organizations() {
  const [organizations, setOrganizations] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [showForm, setShowForm] = useState(false);
  const [editingOrg, setEditingOrg] = useState(null);
  const [formData, setFormData] = useState({
    name: '',
    is_active: true,
  });

  const fetchOrganizations = async () => {
    setLoading(true);
    try {
      const response = await api.getOrganizations();
      setOrganizations(response || []);
      setError(null);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchOrganizations();
  }, []);

  const handleEdit = (org) => {
    setEditingOrg(org);
    setFormData({
      name: org.name,
      is_active: org.is_active,
    });
    setShowForm(true);
  };

  const handleDelete = async (orgId) => {
    if (window.confirm('Are you sure?')) {
      try {
        await api.deleteOrganization(orgId);
        fetchOrganizations();
      } catch (err) {
        setError(err.message);
      }
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (editingOrg) {
        await api.updateOrganization(editingOrg.id, formData);
      } else {
        await api.createOrganization(formData);
      }
      setShowForm(false);
      setEditingOrg(null);
      fetchOrganizations();
    } catch (err) {
      setError(err.message);
    }
  };

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === 'checkbox' ? checked : value,
    });
  };

  return (
    <div className="content-section">
      <h1>Organizations</h1>

      {error && <div className="error-message">{error}</div>}

      <div className="toolbar">
        <button className="btn btn-primary" onClick={() => {
          setEditingOrg(null);
          setFormData({ name: '', is_active: true });
          setShowForm(true);
        }}>
          Add Organization
        </button>
      </div>

      {showForm && (
        <form className="form-container" onSubmit={handleSubmit}>
          <h3>{editingOrg ? 'Edit Organization' : 'Create Organization'}</h3>

          <div className="form-group">
            <label>Name *</label>
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleInputChange}
              required
            />
          </div>

          <div className="form-group">
            <label>
              <input
                type="checkbox"
                name="is_active"
                checked={formData.is_active}
                onChange={handleInputChange}
              />
              Active
            </label>
          </div>

          <div className="form-actions">
            <button type="submit" className="btn btn-primary">Save</button>
            <button
              type="button"
              className="btn btn-secondary"
              onClick={() => setShowForm(false)}
            >
              Cancel
            </button>
          </div>
        </form>
      )}

      {loading ? (
        <p>Loading...</p>
      ) : (
        <table className="table">
          <thead>
            <tr>
              <th>Name</th>
              <th>Users</th>
              <th>Active</th>
              <th>Created</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {organizations.map((org) => (
              <tr key={org.id}>
                <td>{org.name}</td>
                <td>{org.user_count}</td>
                <td>{org.is_active ? '✓' : '-'}</td>
                <td>{new Date(org.created_at).toLocaleDateString()}</td>
                <td>
                  <button
                    className="btn btn-small"
                    onClick={() => handleEdit(org)}
                  >
                    Edit
                  </button>
                  {/* Tạm thời ẩn nút Delete, bật lại khi cần
                  <button
                    className="btn btn-small btn-danger"
                    onClick={() => handleDelete(org.id)}
                  >
                    Delete
                  </button>
                  */}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}

export default Organizations;
